// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCloseButton_root__1hUog","closeText":"ModalCloseButton_closeText__gzLaC","closeButton":"ModalCloseButton_closeButton__2WtqR","icon":"ModalCloseButton_icon__Fu6hu"};